import { Component, inject, signal } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IInformacion } from 'modelos/src';
import { HelperService } from '../../../../auxiliares/servicios/helper.service';
import { NotasService } from '../../../../auxiliares/servicios/http/notas.service';

import { AuxiliaresModule } from '../../../../auxiliares/auxiliares.module';

@Component({
  selector: 'app-detalles-nota',
  templateUrl: './detalles-nota.component.html',
  styleUrl: './detalles-nota.component.scss',
  imports: [AuxiliaresModule],
})
export class DetallesNotaComponent {
  data = inject<IInformacion & { idNota?: string }>(MAT_DIALOG_DATA);
  private helper = inject(HelperService);
  private notasService = inject(NotasService);
  private dialogRef = inject<MatDialogRef<DetallesNotaComponent>>(MatDialogRef);

  public cargandoCodigos = signal(false);
  public codigosSeguridad = signal<{
    palabraSeguridadNormal?: string;
    palabraSeguridadEmergencia?: string;
  } | null>(null);

  public cerrar(): void {
    this.dialogRef.close();
  }

  public async copiarAlPortapapeles(t: string) {
    await this.helper.copiarAlPortapapeles(t);
  }

  public async verCodigosSeguridad() {
    if (!this.data.idNota || this.cargandoCodigos()) return;
    this.cargandoCodigos.set(true);
    try {
      const codigos = await this.notasService.getCodigosSeguridad(
        this.data.idNota,
      );
      this.codigosSeguridad.set(codigos);
    } catch (error) {
      this.helper.notifError(error);
    } finally {
      this.cargandoCodigos.set(false);
    }
  }
}
